export const BASE_URL: string = "/";

// App Configuration
export const APP_NAME: string = import.meta.env.VITE_APP_NAME || "Клиника";